import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, UtensilsCrossed, ShoppingBag, ClipboardList, User } from "lucide-react";
import { useCart } from "../context/CartContext";

const ITEMS = [
  { to: "/", icon: Home, label: "Home" },
  { to: "/menu", icon: UtensilsCrossed, label: "Menu" },
  { to: "/cart", icon: ShoppingBag, label: "Cart" },
  { to: "/account", icon: ClipboardList, label: "Orders" },
  { to: "/account", icon: User, label: "Account" },
];

export function MobileNav() {
  const loc = useLocation();
  const { count } = useCart();
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-navy border-t border-gold/20 flex" data-testid="mobile-bottom-nav">
      {ITEMS.map((it, i) => {
        const active = loc.pathname === it.to;
        const Icon = it.icon;
        return (
          <Link key={i} to={it.to} data-testid={`bottomnav-${it.label.toLowerCase()}`}
            className={`flex-1 flex flex-col items-center justify-center py-2.5 gap-0.5 relative ${active ? "text-gold" : "text-cream/65"}`}>
            <Icon size={19} />
            {it.label === "Cart" && count > 0 && (
              <span className="absolute top-1.5 right-1/2 translate-x-3.5 bg-gold text-navy text-[9px] font-bold rounded-full w-4 h-4 flex items-center justify-center">{count}</span>
            )}
            <span className="text-[10px]">{it.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
